import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";

import { groupItemIdentifierStruct } from "./groupsIdentifierStruct";

export const groupItemResourceStruct = createResourceStruct({
  identifier: groupItemIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
    colorHex: sup.string(),
  }),
});

export const groupsResourceStruct = sup.array(groupItemResourceStruct);

export type GroupItemResource = sup.Infer<typeof groupItemResourceStruct>;
